import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const BidsStructureEditingModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=odMolPd-Q0M&ab_channel=apadua" />
);

export default BidsStructureEditingModal;
